export default __webpack_public_path__ + "static/media/fw-grace-er-Yellow Gold.dfe21ff7.mp4";